<template lang="pug">
    .press-box
        .press-date   {{ date }}
        .press-title    {{ title }}
        .press-content  
            VueSlideToggle(:open="open" tag="section" :duration="500")
                span(v-html="content")
        .press-link(@click="open = !open") 
            span(v-if="!open")     {{ read }} >
            span(v-if="open")     {{ close }} >
</template>

<script>
export default {
    props: ["date", "title", "content", "read", "close"],
    data: function(){
        return {
            open: false
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/atoms/PmContactBox.vue